import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Hero from './components/sections/Hero';
// import Clients from './components/sections/Clients';
import Features from './components/sections/Features';
import Workflow from './components/sections/Workflow';
import Testimonials from './components/sections/Testimonials';
import Pricing from './components/sections/Pricing';
import FAQ from './components/sections/FAQ';
import CTABanner from './components/sections/CTABanner';
import TermsOfService from './components/pages/TermsOfService';
import PrivacyPolicy from './components/pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <Layout>
            <Hero />
            {/* <Clients /> */}
            <Features />
            <Workflow />
            <Testimonials />
            <Pricing />
            <FAQ />
            <CTABanner />
          </Layout>
        } />
        <Route path="/conditions-utilisation" element={<TermsOfService />} />
        <Route path="/politique-confidentialite" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
